var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('h4',{staticClass:"content_msg"},[_vm._v(_vm._s(this.msg))]),_c('b-button',{attrs:{"variant":"primary"},on:{"click":_vm.useESS}},[_vm._v(_vm._s(_vm.$t("iAMSmartContinue")))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }